(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-shop-grid"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-footer-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-sticky-footer-nav]');
    if (!nav) return;

    var buttons = nav.querySelectorAll('[data-target]');

    function resolveTarget(selector) {
      if (!selector) return null;

      var looksLikeBareId = /^[a-zA-Z0-9_-]+$/.test(selector);
      if (looksLikeBareId) {
        return document.getElementById(selector);
      }

      try {
        return document.querySelector(selector);
      } catch (e) {
        return null;
      }
    }

    var chatObserver = null;
    var currentChatBottom = 0;

    function setChatBottom(px) {
      currentChatBottom = px;
      var chat = document.querySelector('#ShopifyChat');
      if (!chat) return;

      chat.style.setProperty('bottom', px + 'px', 'important');

      if (!chatObserver) {
        chatObserver = new MutationObserver(function () {
          var chat = document.querySelector('#ShopifyChat');
          if (chat && chat.style.bottom !== currentChatBottom + 'px') {
            chatObserver.disconnect();
            chat.style.setProperty('bottom', currentChatBottom + 'px', 'important');
            chatObserver.observe(chat, { attributes: true, attributeFilter: ['style'] });
          }
        });
        chatObserver.observe(chat, { attributes: true, attributeFilter: ['style'] });
      }
    }

    function isVisible(el) {
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      if (rect.height === 0) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      return true;
    }

    function updateNavOffset() {
      var addToCart = document.querySelector('[data-essential-cart-element="content-container-mobile"]');
      var cartHeight = isVisible(addToCart) ? addToCart.getBoundingClientRect().height : 0;

      nav.style.bottom = cartHeight + 'px';

      requestAnimationFrame(function () {
        var navHeight = nav.getBoundingClientRect().height;
        setChatBottom(cartHeight + navHeight + 8);
      });
    }

    updateNavOffset();

    var resizeObserver = null;
    var mutationObserver = new MutationObserver(function () {
      var addToCart = document.querySelector('[data-essential-cart-element="content-container-mobile"]');

      if (addToCart) {
        updateNavOffset();
        if (!resizeObserver) {
          resizeObserver = new ResizeObserver(updateNavOffset);
          resizeObserver.observe(addToCart);
        }
      } else {
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
        updateNavOffset();
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selector = button.getAttribute('data-target');
        if (!selector) return;

        var target = resolveTarget(selector.trim());

        if (!target) {
          return;
        }

        var details = null;
        if (target.tagName === 'DETAILS') {
          details = target;
        } else {
          details = target.querySelector('details');
        }

        if (details && !details.open) {
          details.open = true;
        }

        var headerEl = document.querySelector('#header-group #header-component');
        var headerOffset = 0;
        if (headerEl) {
          headerOffset = headerEl.getBoundingClientRect().height;
        }

        setTimeout(function () {
          var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 12;
          window.scrollTo({
            top: targetTop,
            behavior: 'smooth',
          });
        }, 50);

        buttons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
